import { useEffect, useRef } from "react";
import JVConversations from "./JVConversations";
import JVChat from "./JVChat";
import { IConversation, IMessage, IUser } from "./modal";

// import profilePic from "../../assets/Images/profile_pic_placeholder.jpg";
import { useNotification } from "../NotificatonContext";
import { CustomToast } from "../../components";
import { useFetch } from "../../hooks/useFetch";
import { Box, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, Text, useToast } from "@chakra-ui/react";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";

const TASK_ROUTES = {
  my: "/my-task",
  review: "/review-task",
  all: "/task-management",
} as const;

export default function JVConnect() {
  //   const myId = JSON.parse(sessionStorage.getItem("auth") ?? "").id;

  const { loginObj } = useAuth();
  const myId = Number(loginObj?.userId ?? loginObj?.userId);
  const myIdRef = useRef(myId);
  useEffect(() => {
    myIdRef.current = myId;
  }, [myId]);
  const { connection, getUserById, setUsersFromArray, updateOnlineUsers, open, setOpen, conversations, setConversations, currentConversationId, setCurrentConversationId } = useNotification();
  const toast = useToast();

  const navigate = useNavigate();

  const navigateRef = useRef(navigate);

  useEffect(() => {
    navigateRef.current = navigate;
  });

  const getUserNameRef = useRef<(id: number) => string>(() => "Someone");

  const conversationsRef = useRef(conversations);
  const loadConversationsRef = useRef<() => void>(() => {});
  useEffect(() => {
    conversationsRef.current = conversations;
    loadConversationsRef.current = () => loadConversations([]);
  });

  const unreadCount =
    conversations?.reduce((count, u) => {
      return (count += u.unreadCount);
    }, 0) ?? 0;

  const currentConversationRef = useRef<number | undefined>(null);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const openRef = useRef<boolean>(false);
  useEffect(() => {
    currentConversationRef.current = currentConversationId;
  }, [currentConversationId]);
  useEffect(() => {
    openRef.current = open;
  }, [open]);

  useEffect(() => {
    getUserNameRef.current = (id: number) => getUserById(id)?.name ?? "New message";
  });
  useEffect(() => {
    if (!currentConversationId || !open) return;
    const currentConversation = conversations?.find((c) => c.id === currentConversationId);
    if (!currentConversation) {
      loadConversations([]);
      return;
    }
    const messsages = currentConversation.messages;
    if (!messsages || messsages.length === 0) loadChatHistory(currentConversationId);
    else if (currentConversation.unreadCount > 0) markReadConversation(currentConversationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentConversationId, open, conversations.length]);

  async function loadUsers() {
    const res = await fetchApi<IUser[]>("Experiment/jv-users", "GET");
    if (res) {
      setUsersFromArray(res);
      await loadConversations(res);
    }
  }

  async function loadConversations(users: IUser[]) {
    const res = await fetchApi<IConversation[]>("Experiment/my-conversations", "GET");
    if (res) {
      setConversations(res);
    }
  }

  //   async function startConversation(taskId: number) {
  //     const res = await fetchApi("Experiment/start-conversation", "POST", null, `taskId=${taskId}`);
  //     if (res) {
  //       setConversations((prev) => {
  //         const updated = prev?.map((conv) =>
  //           conv.taskId === res.userId
  //             ? {
  //                 ...res,
  //               }
  //             : conv,
  //         );
  //         setCurrentConversationId(res.id);
  //         return updated;
  //       });
  //     }
  //   }

  useEffect(() => {
      if (!loginObj?.userId) return;
    loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginObj?.userId]);

  useEffect(() => {
    if (!connection) return;

    connection.on("OnlineUsers", (users: number[]) => {
      updateOnlineUsers("set", users);
    });

    connection.on("UserOnline", (userId: number) => {
      updateOnlineUsers("add", userId);
    });

    connection.on("UserOffline", (userId: number) => {
      updateOnlineUsers("remove", userId);
    });

    // connection.on("ReceiveMessage", (message: IMessage) => {
    //   message.sender = getUserById(message.senderId)!;
    //   setConversations((prev) => {
    //     const existing = prev?.find((f) => f.id === message.conversationId);
    //     if (existing) {
    //       const updatedConversation = {
    //         ...existing,
    //         lastMessage: message.fileName ?? message.message,
    //         lastMessageTime: message.createdAt,
    //         messages: existing.messages ? [...existing.messages, message] : existing.messages,
    //         unreadCount: !openRef.current || (message.conversationId !== currentConversationRef.current && message.senderId !== myId) ? existing.unreadCount + 1 : existing.unreadCount,
    //       };

    //       const filtered = prev ? prev.filter((f) => f.id !== message.conversationId) : [];
    //       return [updatedConversation, ...filtered];
    //     } else {
    //       const newConversation: IConversation = {
    //         id: message.conversationId,
    //         lastMessage: message.fileName ?? message.message,
    //         lastMessageTime: message.createdAt,
    //         messages: [message],
    //         unreadCount: 1,
    //       };
    //       const filtered = prev ?? [];
    //       return [newConversation, ...filtered];
    //     }
    //   });

    //   if (!openRef.current || (message.conversationId !== currentConversationRef.current && message.senderId !== myId)) {
    //     const user = getUserById(message.senderId);
    //     toast.current.clear();
    //     toast.current.show({
    //       severity: "info",
    //       summary: message.fileName ?? message.message,
    //       life: 5000,
    //       content: (props: any) => (
    //         <div className="flex flex-column align-items-left" style={{ flex: "1" }}>
    //           <div className="flex align-items-center gap-2">
    //             <div style={styles.avatar}>{user?.name.charAt(0).toUpperCase()}</div>
    //             <span className="font-bold text-900">{user?.name}</span>
    //           </div>
    //           <div style={styles.notificationMessage} className="font-medium text-lg my-3 text-900">
    //             {props.message.summary}
    //           </div>
    //           <div>
    //             <Button
    //               className="p-button-sm"
    //               onClick={() => {
    //                 setCurrentConversationId(message.conversationId);
    //                 setOpen(true);
    //               }}
    //             ></Button>
    //           </div>
    //         </div>
    //       ),
    //     });
    //   }
    // });

    connection.on("ReceiveMessage", (message: IMessage) => {
      if (!conversationsRef.current.some((c) => c.id === message.conversationId)) {
        loadConversationsRef.current();
      }
      const isMine = message.senderId === myIdRef.current;
      const isViewing = openRef.current && message.conversationId === currentConversationRef.current;
      const isMyConversation = conversationsRef.current.some((c) => c.id === message.conversationId);

      setConversations((prev) => {
        const existing = prev.find((c) => c.id === message.conversationId);
        if (!existing) return prev;
        const updated = {
          ...existing,
          lastMessage: message.fileName ?? message.message,
          lastMessageTime: message.createdAt,
          messages: existing.messages ? [...existing.messages, message] : existing.messages,
          unreadCount: isMine || isViewing ? existing.unreadCount : existing.unreadCount + 1,
        };
        return [updated, ...prev.filter((c) => c.id !== message.conversationId)];
      });

      if (isViewing && !isMine) markReadConversation(message.conversationId);

      if (!isMine && !isViewing && isMyConversation) {
        const mentionedMe = (message.mentions ?? "").split(",").includes(String(myIdRef.current));
        const senderName = getUserNameRef.current(message.senderId) + (mentionedMe ? " mentioned you" : "");
        const body = message.fileName ?? message.message;
        const toastId = `chat-${message.conversationId}`;

        const openThisChat = () => {
          // console.log("target:", message.target, "->", TASK_ROUTES[message.target ?? "my"]);
          setCurrentConversationId(message.conversationId);
          setOpen(true);
          toast.close(toastId);
          navigateRef.current(TASK_ROUTES[message.target ?? "my"]);
        };
        const options = {
          id: toastId,
          duration: 5000,
          position: "top-right" as const,
          render: () => (
            <Box
              role="button"
              tabIndex={0}
              position="relative"
              zIndex={9999}
              pointerEvents="auto"
              cursor="pointer"
              bg="#5eae7a"
              color="#F3E9DA"
              borderRadius="8px"
              px="14px"
              py="10px"
              boxShadow="lg"
              maxW="320px"
              _hover={{ bg: "#4a6ea8" }}
              onClick={(e) => {
                e.stopPropagation();
                openThisChat();
              }}
              onKeyDown={(e) => e.key === "Enter" && openThisChat()}
            >
              <Text fontWeight="700" fontSize="sm">
                {senderName}
              </Text>
              <Text fontSize="sm" noOfLines={2}>
                {body}
              </Text>
            </Box>
          ),
        };

        if (toast.isActive(toastId)) toast.update(toastId, options);
        else toast(options);
      }
    });

    return () => {
      connection.off("OnlineUsers");
      connection.off("UserOnline");
      connection.off("UserOffline");
      connection.off("ReceiveMessage");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connection]);

  async function loadChatHistory(conversationId: number) {
    if (!conversationId) return;

    const res = await fetchApi<IMessage[]>("Experiment/chat-history", "GET", null, `conversationId=${conversationId}`);

    const messages = Array.isArray(res) ? res : [];

    setConversations((prev) => prev?.map((conv) => (conv.id === conversationId ? { ...conv, messages } : conv)));

    if (messages.length > 0) markReadConversation(conversationId);
  }

  async function markReadConversation(conversationId: number) {
    if (!conversationId) return;
    const res = await fetchApi("Experiment/mark-as-read", "POST", null, `conversationId=${conversationId}`);
    if (res) {
      setConversations((prev) => prev?.map((conv) => (conv.id === conversationId ? { ...conv, unreadCount: 0 } : conv)));
    }
  }
  const current = conversations.find((c) => c.id === currentConversationId);

  return (
    <>
      <button type="button" className="p-link" onClick={() => setOpen(true)}>
        <i className="pi pi-comments"></i>
        {unreadCount > 0 && <span className="topbar-badge">{unreadCount}</span>}
      </button>

      <Drawer isOpen={open} placement="right" size="md" onClose={() => setOpen(false)}>
        <DrawerOverlay bg="blackAlpha.300" />
        <DrawerContent>
          <DrawerCloseButton top={3} />
          {current ? <JVChat myId={myId} conversation={current} onBack={() => setCurrentConversationId(undefined)} /> : <JVConversations conversations={conversations} currentConversationId={currentConversationId} onSelectConversationId={setCurrentConversationId} />}
        </DrawerContent>
      </Drawer>
      {/* <Toast ref={toast} /> */}
    </>
  );
}

// const styles: Record<string, React.CSSProperties> = {
//   container: { display: "flex", height: "100%", width: "100%", backgroundColor: "#f5f7fb", fontFamily: "Segoe UI" },
//   avatar: { width: 28, height: 28, borderRadius: "50%", backgroundColor: "#4e73df", color: "white", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 600, position: "relative" },
//   avatarImg: { width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" },
//   notificationMessage: { display: "-webkit-box", WebkitLineClamp: 5, WebkitBoxOrient: "vertical", overflow: "hidden", fontSize: 28 },
// };
